import i18next from "i18next";
import React from "react";
import { getLayerConfig } from "./SearchUtils";
import { useMapContext } from "../../Contexts/MapContext";
import { useSearchContext } from "../../Contexts/SearchContext";
import "./SearchHelp.scss";

export const SearchHelp = (): JSX.Element => {
    const { configA } = useMapContext();
    const { selectedGroup } = useSearchContext();

    const strings = {
        searchHelp: i18next.t("searchPanel.searchHelp"),
        searchHelpIntro: i18next.t("searchPanel.searchHelpIntro")
    };

    const searchGroupConfig = configA.search.groups.filter((group) => group.id === selectedGroup.value)[0];

    const introText = strings.searchHelpIntro.replace(new RegExp("\\{0\\}", "g"), searchGroupConfig.label);

    return (
        <>
            {!configA.search ? null : (
                <div className="help-text">
                    <div>{introText}</div>
                    <ul>
                        {searchGroupConfig.services.map((searchServiceConfig) =>
                            searchServiceConfig.layerIds.map((layerId: number) => {
                                const layerConfig = getLayerConfig(
                                    searchServiceConfig.serviceId,
                                    layerId,
                                    configA.layers
                                );
                                if (!layerConfig) {
                                    return;
                                }

                                const layerLabel = layerConfig ? layerConfig.label : null;

                                return layerLabel && layerConfig.queryHelp ? (
                                    <li key={`${searchServiceConfig.serviceId}_${layerId}`}>
                                        <b>{layerLabel}</b>
                                        <div dangerouslySetInnerHTML={{ __html: layerConfig.queryHelp }} />
                                    </li>
                                ) : null;
                            })
                        )}
                    </ul>
                </div>
            )}
        </>
    );
};
